import { gql } from '@apollo/client';

export const INTEGRATION_ERROR_FIELDS = gql`
    fragment IntegrationErrorFields on integration_errors {
        client_id
        count
        entity_id
        error_id
        id
        message
        status
        type
        created_at
    }
`;
